module.exports = __webpack_public_path__ + "media/WEB_MP4_REEL_V1.7a7cb975.mp4";